import {
  getAutomationTemplateById,
  type AutomationTemplateId,
} from "@repo/app-types/entities/automation";
import { MarkdownContent } from "@repo/ui/markdown/markdownContent";
import type { FC } from "react";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

export interface AutomationTemplateDescriptionProps {
  templateId: AutomationTemplateId;
}

/**
 * The agent template's overview text, collapsed to its lead paragraph with a
 * "See more" toggle for the full markdown.
 */
export const AutomationTemplateDescription: FC<
  AutomationTemplateDescriptionProps
> = ({ templateId }) => {
  const template = getAutomationTemplateById(templateId);
  const [isExpanded, setIsExpanded] = useState(false);
  const [leadParagraph = template.overviewMarkdown] =
    template.overviewMarkdown.split("\n\n");

  return (
    <div className="max-w-2xl">
      <div
        className={twMerge(
          "prose prose-sm max-w-none text-sm leading-6 text-muted-foreground",
          "prose-headings:mt-4 prose-headings:mb-2 prose-headings:text-xs prose-headings:font-semibold prose-headings:text-foreground",
          "prose-p:my-0 prose-p:text-sm prose-p:leading-6",
          "prose-ul:my-2 prose-li:my-0.5 prose-li:text-sm prose-li:leading-6",
          "prose-gray",
        )}
      >
        <MarkdownContent>
          {isExpanded ? template.overviewMarkdown : leadParagraph}
        </MarkdownContent>
      </div>
      <button
        type="button"
        className="mt-1 cursor-pointer text-sm font-medium text-indigo-600 hover:text-indigo-700"
        onClick={() => {
          setIsExpanded((wasExpanded) => !wasExpanded);
        }}
      >
        {isExpanded ? "See less" : "See more"}
      </button>
    </div>
  );
};
